<template>
  <div>
    <div class="row mb-3">
      <div class="col-lg-6 col-xl-4 d-flex">
        <button class="btn-transparent">
          <img src="@/assets/img/icons/arrow-left-circle.svg" height="auto" width="35" alt />
        </button>
        <button class="btn-transparent">
          <img src="@/assets/img/icons/arrow-right-circle.svg" height="auto" width="35" alt />
        </button>
        <div class="dropdown-curve-container">
          <!-- <label class="shift-up">Select Cinema</label> -->
          <b-dropdown :text="selected.cinema" variant="dropdown-curve" class="w-100">
            <b-dropdown-item
              v-for="(Cinema, CinemaIndex) in CinemasList"
              :key="CinemaIndex"
              v-on:click="onSelectCinema($event, Cinema)"
            >{{ Cinema.cine_name }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <div class="col-lg-6 col-xl-8">
        <div class="row">
          <div class="col-4">
            <div class="input-material">
              <!-- <input type="date" required="required" /> -->
              <div class="add-datepicker">
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="scheduleObject.sch_start_date"
                  name="uniquename"
                  @selected="doSomethingInParentComponentFunction"
                ></Datepicker>
                <label :class="typeof selectedNewDate === 'object' ? 'active': ''">From Date</label>
              </div>
            </div>
          </div>
          <!-- <div class="col-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="scheduleObject.sch_end_date"
                  name="uniquename"
                  @selected="doSomethingInParentComponentFunction"
                ></Datepicker>
                <label :class="typeof selectedNewDate === 'object' ? 'active': ''">To Date</label>
              </div>
            </div>
          </div>-->
          <div class="col-4 align-self-center">
            <!-- v-if="!selectedMoviesInScreensFlag" -->
            <button v-on:click="getSchedule()" class="btn-blue mw-auto mr-3">Get Schedule</button>
            <!-- <button v-else v-on:click="submitSchedule()" class="btn-blue mw-auto mr-3">Save</button> -->
          </div>
        </div>
      </div>
    </div>

    <div v-if="showScheduleCard" class="schedule-wrapper">
      <div class="d-flex w-100">
        <div class="left-nav">
          <div class="sch-header">Movies</div>
          <div class="schedule-movie-list-wrapper">
            <drag
              v-for="(movie, movieIndex) in MoviesList"
              :key="movieIndex"
              :draggable="true"
              class="movie-card"
              :transfer-data="{ type: 'newMovie', movie: movie, movieIndex:movieIndex }"
            >
              <div class="schedule-movie-card">
                <div>{{ movie.movie_title }} - {{ movie.lang_name }}</div>
                <!-- <img src="@/assets/img/temp/movie.jpg" class="img-fluid" /> -->
                <img v-lazy="baseURL+ movie.md_thumbnail_url" class="img-fluid" />
                <div>{{ movie.mf_name }}</div>
              </div>
            </drag>

            <hr />
          </div>
        </div>

        <div class="right-nav d-flex">
          <div class="schedule-screen-list-wrapper">
            <div
              class="schedule-screen-name"
              v-for="(screen , screenIndex) in ScreenList"
              :key="screenIndex"
            >
              <span>{{screen.screen_name}}</span>

              <!-- <span>Screen&nbsp;{{screenIndex}}</span> -->
            </div>
          </div>

          <div class="screen-time-wrapper">
            <div class="screen-timing-header">
              <div
                class="hour-box-header"
                v-for="(timeHeader , timeHeaderIndex) in  24"
                :key="timeHeaderIndex"
              >
                <strong>{{timeHeaderIndex}}:30</strong>
                <div class="minutes-bar"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar h-75"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar border-0"></div>
              </div>
            </div>

            <div
              class="schedule-screen-row"
              v-for="(screen , screenIndex) in ScreenList"
              :key="screenIndex"
            >
              <drag
                v-for="(screenMovie, screenMovieIndex) in selectedMoviesInScreens[screenIndex].movies"
                :key="'index' + screenIndex+ screenMovieIndex"
                class="movie-horizontal-card"
                :transfer-data="{ type: 'presentMovie', movie: screenMovie }"
                @dragstart="startDrag(screenIndex, screenMovieIndex)"
                v-bind:style="{ 'min-width': screenMovie.length +'px', 'left' : screenMovie.start +'px', 'z-index' : 10 }"
              >
                <!-- style="top: 15px; left: 60px;z-index:10"> -->
                <div class="schedule-card bg-green">
                  <div class="schedule-content">
                    <div>
                      <strong>{{screenMovie.movie_title}}</strong>
                      <small class="d-block">
                        <span>{{screenMovie.mf_name}}</span>
                        {{screenMovie.lang_name}}
                      </small>
                    </div>
                    <!-- <img src="@/assets/img/temp/movie.jpg" /> -->
                    <img v-lazy="baseURL+ screenMovie.md_thumbnail_url" />
                  </div>
                  <div class="schedule-navigations">
                    <button
                      class="btn-schedule-edit"
                      v-on:click="movieSelected = screenMovie;convertToTime()"
                      v-b-modal.updateMovie
                    >Edit</button>

                    <button
                      class="btn-schedule-add"
                      v-on:click="onOpenAddPriceModal(screen,screenMovie,screenIndex,screenMovieIndex)"
                    >Add Price</button>
                    <button
                      v-on:click="onDeleteMovie(screen,screenMovie,screenIndex,screenMovieIndex)"
                      class="btn-schedule-delete"
                    >
                      <img src="@/assets/img/icons/delete-red.svg" height="15" width="15" alt />
                    </button>
                  </div>
                </div>
              </drag>
              <div
                class="hour-box"
                v-for="(hourofDay , hourofDayIndex) in 24"
                :key="hourofDayIndex"
              >
                <drop
                  class="minutes-bar drop"
                  v-for="(minutes, minutesIndex) in 6"
                  :key="'index'+ screenIndex+ minutesIndex"
                  @drop="handleDrop"
                  @dragenter="dragEnter(screenIndex,hourofDay,minutes)"
                ></drop>
              </div>
            </div>

            <!-- <div class="schedule-screen-row" v-for="(loop , screenKey) in 1" :key="screenKey">
              <div class="hour-box" v-for="(time , timingKey) in 10" :key="timingKey">
                <div
                  class="minutes-bar drop"
                  v-for="(minutesBar, minutesBarKey) in 6"
                  :key="minutesBarKey"
                ></div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <!-- UPDATE MOVIE MODAL -->
    <b-modal id="updateMovie" ref="updateMovie" title="Update Movie" hide-footer show>
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <!-- <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>English</strong>
              </div>
            </div>
          </div>-->

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <input
                  type="text"
                  v-on:change="onChangeTime($event)"
                  class="input-theme"
                  :value="movieSelected.ss_start_show_time"
                />
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-8">
                <strong>{{CinemasSettings.cine_interval_time_in_mins}} Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-8">
                <strong>{{CinemasSettings.cine_cleaning_time_in_mins}} Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onUpdate()" class="btn-blue">Update</button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- SAVE MOVIE MODAL -->
    <b-modal id="saveMovie" ref="ratecardmodal" title="Save Movie" hide-footer show>
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{movieSelected.movie_title}}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{movieSelected.lang_name}}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{movieSelected.mf_name}}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Showtime:</div>
              <div class="col-8">
                <strong>{{movieSelected.ss_start_show_time}}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Runtime:</div>
              <div class="col-8">
                <strong>{{convertToHrs(movieSelected.lengthMinutes)}}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time:</div>
              <div class="col-8">
                <strong>{{movieSelected.ss_end_show_time}}</strong>
              </div>
            </div>
          </div>

          <div
            v-for="(SeatTypes, SeatTypesIndex) in selectedScreenSeatTypes"
            :key="SeatTypesIndex"
            class="col-12 border-bottom py-2"
          >
            <div class="row">
              <div class="col-4">{{ SeatTypes.sst_seat_type }}</div>
              <div class="col-8 d-flex align-items-center">
                <select
                  v-on:change="onChangeRateCard($event,SeatTypes,SeatTypesIndex)"
                  v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].scheduleShowPrice[SeatTypesIndex].rate_card_id"
                  class="select-ratecard"
                >
                  <option value>Select Rate Card</option>
                  <option
                    v-for="(Ratecard, RatecardIndex) in  RatecardsList"
                    :key="RatecardIndex"
                    :value="Ratecard.rc_id"
                  >{{ Ratecard.rate_card_name }}</option>
                </select>
              </div>
            </div>
          </div>

          <!-- <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Silver</div>
              <div class="col-8 d-flex align-items-center justify-content-between">
                <select class="select-ratecard">
                  <option disabled value>Select Rate Card</option>
                  <option
                    v-for="(Ratecard, RatecardIndex) in  RatecardsList"
                    :key="RatecardIndex"
                    :value="Ratecard.rc_id"
                  >{{ Ratecard.rate_card_name }}</option>
                </select>
              </div>
            </div>
          </div>-->

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onClickupdateRateCard()" class="btn-blue">Update</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import scheduleService from "@/services/scheduleService";
import moment, { min } from "moment";
import { BASEURL } from "@/config/index.js";
import { uniqBy } from "lodash";

export default {
  data() {
    return {
      baseURL: BASEURL,
      movieSelected: {
        lang_name: "Spanish",
        md_id: 12,
        md_thumbnail_url: "/uploads/movies/1566220586425-dummy.jpg",
        mf_name: "3D",
        movie_id: 7,
        movie_is_active: "Y",
        movie_title: "Frozen 2",
        mrrdr_runtime: 132
      },
      selectedMovieIndex: null,
      selectedScreenIndex: null,
      //
      lists: {
        movies: [],
        cinemas: {
          list: [],
          selectedCinema: {
            cine_name: "select cinema"
          }
        },
        screens: []
      },
      selectedNewDate: "",
      initialSelectedScreen: "Screen 2",
      silderOne: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 7
      },
      silderTwo: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 5
      },
      dropLocation: {
        screen: "",
        hour: "",
        minute: ""
      },
      draggedObject: {
        screen: "",
        length: "",
        oldStart: "",
        newStart: "",
        movie: ""
      },
      selectedMoviesInScreens: [],
      selectedMoviesInScreensFlag: false,

      // Saif

      showScheduleCard: false,
      selectedScreenSeatTypes: [],
      selectedRateCardObject: {},

      CinemasList: [],
      MoviesList: [],
      ScreenList: [],
      RatecardsList: [],
      CinemasSettings: {
        cine_setting_id: null,
        cine_id: null,
        cine_operation_start_time: null,
        cine_operation_end_time: null,
        cine_cleaning_time_in_mins: null,
        cine_setting_ads_time_in_mins: null,
        cine_interval_time_in_mins: null,
        cine_seat_release_time_in_mins: null,
        cine_cutoff_time_in_mins: null,
        cine_setting_is_active: "Y"
      },
      selected: {
        cinema: "Select Cinema"
      },
      scheduleObject: {
        cinema_id: null,
        sch_start_date: null,
        sch_end_date: null,
        sch_is_active: "Y"
      },

      FinalScreenAndMovieScheduleList: [
        {
          screen_id: null,
          screen_name: "",

          // sch_start_date: null,
          // sch_end_date: null,
          // sch_is_active: "Y",
          movies: [
            {
              movie_details_id: null,
              movie_title: null,
              ss_start_show_time: null,
              ss_end_show_time: null,
              ss_start_date: null,
              ss_end_date: null,
              ss_start_date_time: null,
              ss_end_date_time: null,
              ss_is_active: "Y",
              scheduleShowPrice: [
                {
                  rate_card_id: null,
                  schedule_show_id: null,
                  screen_seat_type_id: null,
                  p_start_date_time: null,
                  p_end_date_time: null,
                  p_is_active: "Y"
                }
              ]
            }
          ]
        }
      ],
      FinalArray: []
      // Saif
    };
  },
  beforeMount: function() {
    // this.getAllActiveScreens();
    // this.getAllMovies();
    this.getAllActiveCinemas();
  },
  methods: {
    onChangeTime: function(event) {
      this.movieSelected.start_time = event.target.value;
    },
    onUpdate: function() {
      let start = 0;
      let hours = 0;
      let minutes = 0;
      let totalMinutes = 0;
      let ampm = this.movieSelected.start_time.split(" ")[1];
      minutes = parseInt(this.movieSelected.start_time.split(":")[1]);
      hours = parseInt(this.movieSelected.start_time.split(":")[0]);
      if (ampm == "PM") {
        hours = hours + 12;
      }
      totalMinutes = parseInt(hours * 60);
      start = parseInt(totalMinutes * 30) / 10;
      this.movieSelected.start = start;
      this.convertToTime(
        this.movieSelected.start,
        this.movieSelected.lengthMinutes
      );
      let payload = {
        show_schedule_id: this.movieSelected.scheduleShowPrice[0]
          .schedule_show_id,
        screen_id: this.movieSelected.scheduleShowPrice[0].screen_id,
        ss_start_show_time: this.movieSelected.start_time,
        ss_end_show_time: this.movieSelected.end_time
      };
      console.log("payload :", payload);
      scheduleService.UpdateCinemaScheduleByShow(payload)
        .then(result => {
          console.log("result :", result);
        })
        .catch(err => {
          console.log("err :", err);
        });
      this.$refs.updateMovie.hide();
    },
    convertToTime: function(value, value1) {
      let totalMinutes = (this.movieSelected.start * 10) / 30;
      let _totalMinutes = Math.floor(
        totalMinutes + this.movieSelected.lengthMinutes
      );

      let _hours = Math.floor(_totalMinutes / 60);
      let _minutes = _totalMinutes % 60;
      let _ampm = "AM";
      if (_hours > 12) {
        _ampm = "PM";
        _hours = _hours - 12;
      }
      _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;
      this.movieSelected.end_time = _hours + ":" + _minutes + " " + _ampm;

      let hours = Math.floor(totalMinutes / 60);
      let minutes = Math.floor(totalMinutes % 60);
      let ampm = "AM";
      if (hours > 12) {
        ampm = "PM";
        hours = hours - 12;
      }
      minutes = minutes >= 10 ? minutes : "0" + minutes;
      this.movieSelected.start_time = hours + ":" + minutes + " " + ampm;
      return hours + ":" + minutes + " " + ampm;
    },
    convertToHrs: function(value) {
      let hours = Math.floor(value / 60);
      let minutes = Math.floor(value % 60);
      return hours + "." + minutes + " Hrs";
    },
    getSchedule: async function() {
      let payload = {
        cinema_id: this.scheduleObject.cinema_id,
        start_date: moment(this.scheduleObject.sch_start_date).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.scheduleObject.sch_start_date).format(
          "YYYY-MM-DD"
        )
      };
      scheduleService.GetCinemaSchedule(payload)
        .then(result => {
          const { data } = result;
          if (data.status) {
            let newRecords = data.Records;
            let _newRecords = uniqBy(newRecords, "screen_id");
            _newRecords.map(y => {
              this.selectedMoviesInScreens = this.selectedMoviesInScreens.map(
                x => {
                  if (y.screen_id == x.screen_id) {
                    let lengthMinutes =
                      y.mrrdr_runtime +
                      y.cine_cleaning_time_in_mins +
                      y.cine_setting_ads_time_in_mins +
                      y.cine_interval_time_in_mins;
                    x.movies.push({
                      lengthMinutes: lengthMinutes,
                      length: (lengthMinutes * 10) / 30,
                      start: getLength(y.ss_start_show_time),
                      movie_details_id: y.movie_id,
                      lang_name: y.language_name,
                      mf_name: y.movie_format,
                      movie_title: y.movie_title,
                      md_thumbnail_url: y.md_thumbnail_url,
                      ss_start_show_time: y.ss_start_show_time,
                      ss_end_show_time: y.ss_end_show_time,
                      scheduleShowPrice: y.scheduleShowPrice,
                      ss_start_date: y.ss_start_date,
                      ss_end_date: y.ss_end_date,
                      ss_start_date_time: y.ss_start_date_time,
                      ss_end_date_time: y.ss_end_date_time,
                      ss_is_active: "Y"
                    });
                  }
                  return x;
                }
              );
            });
            console.log(
              "this.selectedMoviesInScreens :",
              this.selectedMoviesInScreens
            );
            this.selectedMoviesInScreensFlag = true;
          }
        })
        .catch(err => {});
      function getLength(startTime) {
        let start = 0;
        let hours = 0;
        let minutes = 0;
        let totalMinutes = 0;
        let ampm = startTime.split(" ")[1];
        minutes = parseInt(startTime.split(":")[1]);
        hours = parseInt(startTime.split(":")[0]);
        if (ampm == "PM") {
          hours = hours + 12;
        }
        totalMinutes = parseInt(hours * 60);
        start = parseInt(totalMinutes * 30) / 10;
        return start;
      }
    },
    submitSchedule: async function() {
      // this.selectedMoviesInScreens.map((screen, screenIndex) => {
      //   this.screen.movie.map((singleMovie, singleMovieIndex) => {
      //     singleMovie.startTime = singleMovie.start;
      //     return singleMovie;
      //   });
      //   //API Call schedule
      // });

      this.FinalArray = [];
      let dates = getDates(
        moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD"),
        moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD")
      );

      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        var stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
      }

      this.FinalScreenAndMovieScheduleList = this.selectedMoviesInScreens.filter(
        x => {
          return x.movies.length > 0;
        }
      );
      console.log(
        "this.FinalScreenAndMovieScheduleList :",
        this.FinalScreenAndMovieScheduleList
      );

      console.log("dates :", dates);
      let dateCount = 0;

      let finalpromises = dates.map(async (date, dateIndex) => {
        let promises = this.FinalScreenAndMovieScheduleList.map(
          async (item, itemIndex) => {
            let MainObj = {};
            MainObj["screen_id"] = item.screen_id || null;
            MainObj["sch_start_date"] =
              moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") ||
              null;
            MainObj["sch_end_date"] =
              moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") ||
              null;
            MainObj["sch_is_active"] = this.scheduleObject.sch_is_active || "Y";

            // Single Screen data
            // MainObj["sch_start_date"] = item.sch_start_date || null;
            // MainObj["sch_end_date"] = item.sch_end_date || null;
            // MainObj["sch_is_active"] = item.sch_is_active || "Y";
            // schedule show according movie // Movie Mapping

            MainObj["scheduleshow"] = [];

            let moviePromises = item.movies.map(async (movie, movieIndex) => {
              let MovieObj = {};
              MovieObj["cinema_id"] = this.scheduleObject.cinema_id;
              MovieObj["screen_id"] = item.screen_id;
              MovieObj["movie_details_id"] = movie.movie_details_id;
              let totalMinutes = (movie.start * 10) / 30;
              let _totalMinutes = totalMinutes + movie.lengthMinutes;
              let _hours = Math.floor(_totalMinutes / 60);
              let hours = Math.floor(totalMinutes / 60);
              let minutes = totalMinutes % 60;
              let _minutes = _totalMinutes % 60;
              let ampm = "AM";
              let _ampm = "AM";
              if (hours > 12) {
                ampm = "PM";
                hours = hours - 12;
              }
              if (_hours > 12) {
                _ampm = "PM";
                _hours = _hours - 12;
              }
              // _hours = _hours >= 10 ? _hours : "0" + _hours;
              // hours = hours >= 10 ? hours : "0" + hours;
              minutes = minutes >= 10 ? minutes : "0" + minutes;
              _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;
              let showtime = hours + ":" + minutes + " " + ampm;
              let endShowtime = _hours + ":" + _minutes + " " + _ampm;
              MovieObj["ss_start_show_time"] = showtime;
              MovieObj["ss_end_show_time"] = endShowtime;
              MovieObj["ss_start_date"] = date; // movie.ss_start_date;
              MovieObj["ss_end_date"] = date; // movie.ss_end_date;
              MovieObj["ss_start_date_time"] = toUnixTimeStamp(
                date + " " + showtime
              );
              MovieObj["ss_end_date_time"] = toUnixTimeStamp(
                date + " " + endShowtime
              );
              MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time;

              // array scheduleshowprice
              MovieObj["scheduleshowprice"] = [];
              let scheduleShowPricePromises = movie.scheduleShowPrice.map(
                (price, priceIndex) => {
                  let PriceObj = {};

                  dateCount = PriceObj[
                    "cinema_id"
                  ] = this.scheduleObject.cinema_id;
                  PriceObj["screen_id"] = item.screen_id;
                  PriceObj["md_id"] = movie.movie_details_id;
                  PriceObj["rate_card_id"] = price.rate_card_id;
                  PriceObj["schedule_show_id"] = price.schedule_show_id;
                  PriceObj["screen_seat_type_id"] = price.screen_seat_type_id;
                  PriceObj["p_start_date_time"] = price.p_start_date_time;
                  PriceObj["p_end_date_time"] = price.p_end_date_time;
                  PriceObj["p_is_active"] = price.p_is_active || "Y";

                  // Push Show Price
                  MovieObj["scheduleshowprice"].push(PriceObj);
                }
              );
              await Promise.all(scheduleShowPricePromises);

              // Push Show and Show Price
              MainObj["scheduleshow"].push(MovieObj);
            });
            await Promise.all(moviePromises);
            // Final Array Push
            this.FinalArray.push(MainObj);
          }
        );
        await Promise.all(promises);
      });

      function toUnixTimeStamp(Datestring) {
        return new Date(Datestring.toString()).getTime() / 1000;
      }
      await Promise.all(finalpromises);
      console.log("this.FinalArray :", this.FinalArray);
      // .then(result => {
      //   this.FinalArray.map(x => {
      //     scheduleService.AddSchedule(x)
      //       .then(result => {
      //         console.log("result :", result);
      //       })
      //       .catch(err => {});
      //   });
      // })
      // .catch(err => {});
      // this.onFinalSubmit();
    },
    onFinalSubmit: function() {
      this.submitSchedule()
        .then(() => {
          this.FinalArray.map(x => {
            scheduleService.AddSchedule(x)
              .then(result => {
                console.log("result :", result);
              })
              .catch(err => {});
          });
        })
        .catch(error => {
          console.log("Reached Catch :", error);
        });
    },
    getDateTime(date, time) {
      return moment(new Date(date)).format("DD-MM-YYYY");
    },
    // Cinema List
    getAllActiveCinemas: function() {
      scheduleService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveCinemas :", error);
        });
    },

    getCinemaSetting: function(cinema_id) {
      scheduleService.GetCinemaSetting({ cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasSettings = {
              ...this.CinemasSettings,
              ...data.Records[0]
            };
            this.getAllActiveMovies();
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },
    //
    getRatecardsList: function(cinema_id) {
      scheduleService.GetRatecardByCinemaId({ cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("data.Records :", data.Records);
            this.RatecardsList = data.Records;
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },

    getAllActiveMovies: function() {
      scheduleService.GetMovies()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            this.MoviesList = data.MovieListResult.map((movie, movieIndex) => {
              movie.lengthMinutes =
                movie.mrrdr_runtime +
                this.CinemasSettings.cine_cleaning_time_in_mins +
                this.CinemasSettings.cine_setting_ads_time_in_mins +
                this.CinemasSettings.cine_interval_time_in_mins;
              movie.length = (movie.lengthMinutes * 30) / 10;
              movie.rateCard = [];
              movie.scheduleShowPrice = [];
              return movie;
            });
            this.showScheduleCard = true;
            // this.lists.movies = movieList;
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getAllActiveMovies :", error);
        });
    },
    getAllActiveScreens: function(cinema_id) {
      // scheduleService.GetScreens()
      //   .then(response => {
      //     const { data } = response;
      //     if (data && data.status && data.Records.length > 0) {
      //       // this.lists.screens = data.Records;
      //       this.ScreenList = data.Records.filter(
      //         x => x.screen_seat_types.length > 0
      //       );
      //       this.ScreenList.map(x => {
      //         this.selectedMoviesInScreens.push({
      //           ...x,
      //           movies: []
      //         });
      //       });
      //     } else {
      //       // Show Message Here:
      //       console.log("data.message :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     // Catch Error:
      //     this.$toasted.show(Error(error));
      //     console.log("Catch Error on getAllActiveScreens :", error);
      //   });
      this.ScreenList = [];
      let payload = {
        cinema_id: cinema_id
      };

      scheduleService.GetScreens(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.lists.screens = data.Records;
            this.ScreenList = data.Records.filter(
              x => x.screen_seat_types.length > 0
            );
            this.ScreenList.map(x => {
              this.selectedMoviesInScreens.push({
                ...x,
                movies: []
              });
            });
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveScreens :", error);
        });
    },
    getSeatTypesListByScreenId: function(screen_id) {
      scheduleService.GetSeatTypesByScreenId({ screen_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getSeatTypesListByScreenId :", error);
        });
    },
    onOpenAddPriceModal: function(
      screen,
      screenMovie,
      screenIndex,
      screenMovieIndex
    ) {
      this.movieSelected = screenMovie;
      this.selectedScreenSeatTypes = screen.screen_seat_types;
      this.selectedMovieIndex = screenMovieIndex;
      this.selectedScreenIndex = screenIndex;
      this.$refs.ratecardmodal.show();
    },
    onDeleteMovie: function(
      screen,
      screenMovie,
      screenIndex,
      screenMovieIndex
    ) {
      this.selectedMoviesInScreens[screenIndex].movies.splice(
        screenMovieIndex,
        1
      );
    },
    onChangeRateCard: function(event, seat, SeatTypeIndex) {
      this.selectedRateCardObject.rate_card_id = event.target.value;
      this.selectedRateCardObject.screen_seat_type_id = seat.sst_id;
      this.selectedRateCardObject.SeatTypeIndex = SeatTypeIndex;
    },
    onClickupdateRateCard: function() {
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "rate_card_id"
      ] = this.selectedRateCardObject.rate_card_id;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "screen_seat_type_id"
      ] = this.selectedRateCardObject.screen_seat_type_id;
      let payload = {
        show_schedule_id: this.selectedMoviesInScreens[this.selectedScreenIndex]
          .movies[this.selectedMovieIndex].scheduleShowPrice[
          this.selectedRateCardObject.SeatTypeIndex
        ]["schedule_show_id"],
        scheduleshowprice: this.selectedMoviesInScreens[
          this.selectedScreenIndex
        ].movies[this.selectedMovieIndex].scheduleShowPrice
      };
      scheduleService.UpdateCinemaScheduleByPrice(payload)
        .then(result => {
          console.log("result :", result);
        })
        .catch(err => {
          console.log("err :", err);
        });

      this.$refs.ratecardmodal.hide();
    },
    onSelectCinema: function(event, cinema) {
      this.selected.cinema = cinema.cine_name;
      this.scheduleObject.cinema_id = cinema.cine_id;
      this.getAllActiveScreens(cinema.cine_id);
      this.getCinemaSetting(cinema.cine_id);
      this.getRatecardsList(cinema.cine_id);
    },

    //

    selectCinema: function(cinema) {
      this.lists.cinemas.selectedCinema = cinema;
    },

    doSomethingInParentComponentFunction: function() {},
    changeCinema: function(params) {
      this.initialSelectedScreen = params;
    },
    startDrag: function(screen, movie) {
      console.log("screen, movie :", screen, movie);
      // console.log(this.selectedMoviesInScreens[screen].movies[movie]);
      this.draggedObject.screen = screen;
      this.draggedObject.movie = movie;
      this.draggedObject.oldStart = this.selectedMoviesInScreens[screen].movies[
        movie
      ].start;
      this.draggedObject.length = this.selectedMoviesInScreens[screen].movies[
        movie
      ].length;
      this.draggedObject.md_thumbnail_url = this.selectedMoviesInScreens[
        screen
      ].movies[movie].md_thumbnail_url;
      // md_thumbnail_url: y.md_thumbnail_url,
      this.draggedObject.lengthMinutes = this.selectedMoviesInScreens[
        screen
      ].movies[movie].lengthMinutes;

      //check if the drop is overlapping with something else
      //if no overlap,delete old object, else
      //add object to new place
      // this.selectedMoviesInScreens[screen].movies[movie].zIndex = 0;
      // console.log(this.selectedMoviesInScreens[screen].movies[movie]);
    },
    endDrag: function(data) {
      // this.selectedMoviesInScreens[screen].movies[movie].zIndex = 99;

      console.log("drag start", data);
    },

    overLapIssue: function() {},
    dragEnter: function(screen, hour, minute) {
      this.dropLocation.screen = screen;
      this.dropLocation.hour = hour;
      this.dropLocation.minute = minute;
      // this.dropLocation.minute = minute;
    },
    openEditPopUp: function() {
      alert("popup");
    },
    handleDrop: function(data, event) {
      console.log("data :", data);

      // console.log("data, event :", data, event);
      //check if overlap with something else
      console.log("drop", this.dropLocation);
      let draggedMovie = data.movie;
      // console.log("this.draggedObject :", this.draggedObject);
      let doNotClone = 0;
      // let draggedMovie = this.selectedMoviesInScreens[this.draggedObject.screen]
      // .movies[this.draggedObject.movie];

      if (data.type == "presentMovie") {
        draggedMovie = this.selectedMoviesInScreens[this.draggedObject.screen]
          .movies[this.draggedObject.movie];

        this.draggedObject.newStart =
          (this.dropLocation.hour - 1) * 180 +
          (this.dropLocation.minute - 1) * 30;
        this.selectedMoviesInScreens[this.draggedObject.screen].movies[
          this.draggedObject.movie
        ].zIndex = 0;

        console.log("oldMovie :", draggedMovie);
        this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
          (otherMovie, index) => {
            //compare with start and start + length

            // draggedMoviestart > oldMovie start+length || draggedMoviestart +length < oldMovie start
            console.log("index, value :", index, otherMovie);
            console.log(
              "draggedMovie.start1 :",
              draggedMovie.start,
              draggedMovie.length,
              otherMovie.start,
              otherMovie.length,
              draggedMovie.start + draggedMovie.length,
              otherMovie.start + otherMovie.length
            );

            // if (
            //   this.draggedObject.newStart > otherMovie.start &&
            //   !(
            //     otherMovie.start + otherMovie.length <
            //     this.draggedObject.newStart
            //   )
            // ) {
            //   doNotClone = 1;
            //   alert("overlap1");
            // }
            if (
              this.draggedObject.newStart < otherMovie.start &&
              !(
                this.draggedObject.newStart + draggedMovie.length <
                otherMovie.start
              )
            ) {
              doNotClone = 1;
              alert("overlap old movie");
              if (
                this.dropLocation.screen == this.draggedObject.screen &&
                this.draggedObject.movie == index
              ) {
                doNotClone = 0;
              }
            }

            // if (
            //   draggedMovie.start >
            //     parseInt(otherMovie.start) + parseInt(otherMovie.length) ||
            //   parseInt(draggedMovie.start) + parseInt(draggedMovie.length) <
            //     otherMovie.start
            // ) {
            //   doNotClone = 1;
            //   alert("overlap");
            // }
          }
        );
      }

      if (data.type == "newMovie") {
        this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
          (otherMovie, index) => {
            let scheduleShowPriceObj = {
              rate_card_id: null,
              schedule_show_id: null,
              screen_seat_type_id: null,
              p_start_date_time: null,
              p_end_date_time: null,
              p_is_active: "Y"
            };
            otherMovie[0] = { scheduleShowPrice: scheduleShowPriceObj };
            let startCheck =
              (this.dropLocation.hour - 1) * 180 +
              (this.dropLocation.minute - 1) * 30;
            if (
              startCheck < otherMovie.start &&
              !(startCheck + draggedMovie.length < otherMovie.start)
            ) {
              doNotClone = 1;
              alert("overlap new movie");
            }
            // if (otherMovie.movie_details_id == data.movie.md_id) {
            //   let scheduleShowPriceObj = {
            //     rate_card_id: 1,
            //     schedule_show_id: "1",
            //     screen_seat_type_id: "18",
            //     p_start_date_time: 1,
            //     p_end_date_time: 1,
            //     p_is_active: "Y"
            //   };
            //   otherMovie.push({ scheduleShowPrice: scheduleShowPriceObj });
            // }
          }
        );
      }

      //create new movie
      if (doNotClone == 0) {
        // this.selectedMoviesInScreens[
        //   this.dropLocation.screen
        // ].movies = this.selectedMoviesInScreens[
        //   this.dropLocation.screen
        // ].movies.filter((movie, index) => {
        //   console.log("lastCheck", movie);
        //   // if (movie.zIndex == 99) return movie;
        //   return movie.zIndex == 99;
        // });
        // let dropScreen;
        // if(data.type == "presentMovie"){
        //   dropScreen = this.draggedObject.screen;
        // }else if (data.type == "newMovie"){
        //   dropScreen = this.dropLocation.screen;
        // }

        this.selectedMoviesInScreens[this.dropLocation.screen].movies.push({
          length: draggedMovie.length,
          lengthMinutes: draggedMovie.lengthMinutes,
          movie_details_id: draggedMovie.movie_id,
          start:
            (this.dropLocation.hour - 1) * 180 +
            (this.dropLocation.minute - 1) * 30,
          zIndex: 99,
          mf_name: draggedMovie.mf_name,
          md_thumbnail_url: draggedMovie.md_thumbnail_url,
          lang_name: draggedMovie.lang_name,
          movie_title: draggedMovie.movie_title
        });
        this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(x => {
          let scheduleShowPriceObj = {
            rate_card_id: null,
            schedule_show_id: null,
            screen_seat_type_id: null,
            p_start_date_time: null,
            p_end_date_time: null,
            p_is_active: "Y"
          };
          let scheduleShowPriceArray = [];
          scheduleShowPriceArray.push(scheduleShowPriceObj);
          Object.assign(x, { scheduleShowPrice: scheduleShowPriceArray });
          //  x = { ...x,{scheduleShowPrice: scheduleShowPriceObj} };
        });
      }
      if (doNotClone == 1 && data.type != "newMovie") {
        console.log("always");
        this.selectedMoviesInScreens[this.draggedObject.screen].movies.push({
          length: draggedMovie.length,
          lengthMinutes: draggedMovie.lengthMinutes,
          movie_details_id: draggedMovie.movie_id,
          start: draggedMovie.start,
          zIndex: 99,
          mf_name: draggedMovie.mf_name,
          md_thumbnail_url: draggedMovie.md_thumbnail_url,
          lang_name: draggedMovie.lang_name,
          movie_title: draggedMovie.movie_title
        });
      }

      // alert(`You dropped with data: ${JSON.stringify(data)}`);
    },
    closeModalSection: function() {}
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleComponents/EditSchedule.vue